import SmallLoader from "../../loaders/SmallLoader";

// Заголовок для шапки страницы
export default function ContentHeaderTitle({ title }: any) {
    return (
        <div className="content-header-name-div" >
            {!title
                ?
                <span className="content-header-name">
                    <SmallLoader text="Загрузка..." />
                </span>
                :
                <span className="content-header-name">{title}</span>
            }
        </div>
    )
}
